/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ost = __webpack_require__(1);
	
	var navigation = _interopRequireWildcard(_ost);
	
	var _ost2 = __webpack_require__(2);
	
	var loginModal = _interopRequireWildcard(_ost2);
	
	var _ost3 = __webpack_require__(4);
	
	var search = _interopRequireWildcard(_ost3);
	
	var _ost4 = __webpack_require__(5);
	
	var bookmark = _interopRequireWildcard(_ost4);
	
	var _ost5 = __webpack_require__(6);
	
	var calendar = _interopRequireWildcard(_ost5);
	
	var _ost6 = __webpack_require__(7);
	
	var alert = _interopRequireWildcard(_ost6);
	
	var _ost7 = __webpack_require__(8);
	
	var orglist = _interopRequireWildcard(_ost7);
	
	var _ost8 = __webpack_require__(9);
	
	var workroom = _interopRequireWildcard(_ost8);
	
	var _ost9 = __webpack_require__(10);
	
	var quiz = _interopRequireWildcard(_ost9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Index = function () {
	    function Index() {
	        _classCallCheck(this, Index);
	
	        this.navigation = new navigation.Navigation();
	        this.loginModal = new loginModal.LoginModalDialog("#modal-dialog-container");
	        this.search = new search.Search(".js-auto-update-form", ".searchResult");
	        this.bookmark = new bookmark.Bookmark();
	        this.calendar = new calendar.Calendar();
	        this.alert = new alert.AlertBlock(".js-alertblock-button");
	        this.orglist = new orglist.OrganizationList();
	        this.workroom = new workroom.Workroom();
	        this.quiz = new quiz.Quiz();
	    }
	
	    _createClass(Index, [{
	        key: 'init',
	        value: function init() {
	            this.navigation.init();
	            this.loginModal.init();
	            this.search.init();
	            this.bookmark.init();
	            this.calendar.init();
	            this.alert.init();
	            this.orglist.init();
	            this.workroom.init();
	            this.quiz.init();
	        }
	    }]);
	
	    return Index;
	}();
	
	$(document).ready(function () {
	    var index = new Index();
	    index.init();
	
	    $(".nav-link-arrow").click(function (e) {
	        e.preventDefault();
	        var getParent = $(this).parent();
	
	        getParent.toggleClass("expand");
	    });
	
	    // Filter toggle on search page. Not used after redesign 2024
	    //$(".filter-toggle").click(function (e) {
	    //    e.preventDefault();
	    //    const searchFilter = $(".search-filter");
	
	    //    searchFilter.toggleClass("active");
	    //});
	
	    $(".arrow").click(function (e) {
	        e.preventDefault();
	        var getParent = $(this).parent();
	
	        getParent.toggleClass("expand");
	    });
	});
	
	$(document).mouseup(function (e) {
	    var container = $(".nav-shortcuts");
	
	    // if the target of the click isn't the container nor a descendant of the container
	    if (!container.is(e.target) && container.has(e.target).length === 0) {
	        container.removeClass('active');
	    }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Navigation = exports.Navigation = function () {
	    function Navigation() {
	        _classCallCheck(this, Navigation);
	
	        this.$toggleFallouts = $(".toggle-fallout");
	        this.$shortcutToggle = $(".shortcut-toggle");
	        this.menuIsOpen = false;
	    }
	
	    _createClass(Navigation, [{
	        key: "init",
	        value: function init() {
	            var _this = this;
	
	            this.$toggleFallouts.on("click", function (ev) {
	                return _this.toggleFallouts(ev);
	            });
	            this.$shortcutToggle.click(function (e) {
	                return _this.shortcutToggleClick(e);
	            });
	
	            $('#navbarSupportedContent').on('shown.bs.collapse', function () {
	                _this.menuIsOpen = true;
	            });
	
	            $('#navbarSupportedContent').on('hidden.bs.collapse', function (e) {
	                _this.menuIsOpen = false;
	            });
	        }
	    }, {
	        key: "shortcutToggleClick",
	        value: function shortcutToggleClick(e) {
	            e.preventDefault();
	
	            var getParent = $(".nav-shortcuts");
	
	            getParent.toggleClass("active");
	        }
	    }, {
	        key: "toggleFallouts",
	        value: function toggleFallouts(ev) {
	            ev.preventDefault();
	            /* Toggle menu icon state */
	            if (this.menuIsOpen) {
	                this.$toggleFallouts.find(".menu-icon.menu-opened").toggleClass("menu-opened").toggleClass("menu-closed");
	            } else {
	                this.$toggleFallouts.find(".menu-icon.menu-closed").removeClass("menu-closed").addClass("menu-opened");
	            }
	        }
	    }]);

	    return Navigation;
	}();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LoginModalDialog = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ost = __webpack_require__(3);
	
	var loginModal = _interopRequireWildcard(_ost);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginModalDialog = exports.LoginModalDialog = function (_loginModal$ModalDial) {
	    _inherits(LoginModalDialog, _loginModal$ModalDial);
	
	    function LoginModalDialog(selector) {
	        _classCallCheck(this, LoginModalDialog);
	
	        return _possibleConstructorReturn(this, (LoginModalDialog.__proto__ || Object.getPrototypeOf(LoginModalDialog)).call(this, selector));
	    }
	
	    _createClass(LoginModalDialog, [{
	        key: 'init',
	        value: function init() {
	            var _this2 = this;
	
	            $(document).on('click', '.js-login-button', function (e) {
	                return _this2.loginFormSubmit(e);
	            });
	            _get(LoginModalDialog.prototype.__proto__ || Object.getPrototypeOf(LoginModalDialog.prototype), 'init', this).call(this);
	        }
	    }, {
	        key: 'loginFormSubmit',
	        value: function loginFormSubmit(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	            var $button = $(e.currentTarget);
	            var $form = $button.closest("form");
	
	            var modalBody = $('#js-login-modal-body');
	            var loader = $('.loader');
	
	            $('#login-form-errors').hide();
	
	            if (!$form.valid()) return;
	
	            $button.addClass("disabled").button("loading");
	
	            modalBody.css('visibility', 'hidden');
	            loader.removeClass('hide');
	
	            var updateUrl = $form.attr("action");
	            var data = $form.serialize();
	
	            $.ajax({
	                url: updateUrl,
	                type: "POST",
	                data: data,
	                success: function success(data, textStatus, jqXHR) {
	                    if (data.success === true) {
	                        if (data.redirectUrl) {
	                            _this3.$currentModal.one('hidden.bs.modal', function (e2) {
	                                _get(LoginModalDialog.prototype.__proto__ || Object.getPrototypeOf(LoginModalDialog.prototype), 'getAndLoadDiv', _this3).call(_this3, data.redirectUrl, ".modal");
	                            });
	                            _this3.$currentModal.modal("hide");
	                        } else window.location.reload(true);
	                    } else if (data.errors) {
	                        modalBody.css('visibility', 'visible');
	                        loader.addClass('hide');
	
	                        _this3.setLoginErrorMessage("", true);
	                        $('#login-form-errors').show();
	                        for (var error in data.errors) {
	                            _this3.setLoginErrorMessage(data.errors[error] + '<br />');
	                        }
	                    }
	                },
	                error: function error(resp) {
	                    _this3.setLoginErrorMessage("Ett fel inträffade", true);
	                }
	            });
	
	            return false;
	        }
	    }, {
	        key: 'setLoginErrorMessage',
	        value: function setLoginErrorMessage(msg, clearFirst) {
	            if (clearFirst) $('#login-form-errors').html("");
	
	            if (msg) $('#login-form-errors').append(msg);
	        }
	    }]);
	
	    return LoginModalDialog;
	}(loginModal.ModalDialog);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalDialog = exports.ModalDialog = function () {
	    function ModalDialog(selector) {
	        _classCallCheck(this, ModalDialog);
	
	        this.$modalDialogContainer = $(selector);
	        this.$currentModal = null;
	    }
	
	    _createClass(ModalDialog, [{
	        key: "init",
	        value: function init() {
	            var _this = this;
	
	            $(".modal-dialog-link").on('click', function (e) {
	                return _this.modalDialogClick(e);
	            });
	        }
	    }, {
	        key: "modalDialogClick",
	        value: function modalDialogClick(e) {
	            var $button = $(e.currentTarget);
	            var url = $button.data("modal-dialog-url");
	            this.getAndLoadDiv(url, ".modal");
	            e.preventDefault();
	        }
	    }, {
	        key: "getAndLoadDiv",
	        value: function getAndLoadDiv(url, divSelector) {
	            var _this2 = this;
	
	            $.get(url, function (data) {
	                _this2.$modalDialogContainer.html(data);
	                _this2.$currentModal = _this2.$modalDialogContainer.find(divSelector);
	                _this2.$currentModal.modal('show');
	                var forms = _this2.$modalDialogContainer.find("form");
	                if (forms.length > 0) $.validator.unobtrusive.parse(forms[0]);
	            });
	        }
	    }]);

	    return ModalDialog;
	}();

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Search = exports.Search = function () {
	    function Search(inputSelector, resultSelector) {
	        _classCallCheck(this, Search);
	
	        this.$refreshSearchInputs = $(inputSelector); // Inputs triggering search
	        this.$resultContainer = $(resultSelector); // Results container
	    }
	
	    _createClass(Search, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.$refreshSearchInputs.change(function (e) {
	                return _this.handleChange(e);
	            }); // Listen for changes
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            var $input = $(e.currentTarget);
	            var $form = $input.closest("form");
	
	            // Check for Year and Month dropdowns for specific functionality
	            if ($form.find('select[name="y"]').length > 0) {
	                var yearValue = $form.find('select[name="y"]').val();
	                var monthValue = $form.find('select[name="m"]').val();
	
	                // Reset Month dropdown if Year is deselected
	                if (yearValue === "") {
	                    $form.find('select[name="m"]').val('');
	
	                    // Trigger a search when Year is deselected
	                    this.submitForm($form);
	                    return; // Prevent further checks
	                }
	
	                // Prevent submission if only a Month is selected without a Year
	                if (monthValue !== "" && yearValue === "") {
	                    return; // Block submission if invalid state
	                }
	            }
	
	            // Submit the form for all other cases
	            this.submitForm($form);
	        }
	    }, {
	        key: 'submitForm',
	        value: function submitForm($form) {
	            var _this2 = this;
	
	            var data = $form.serialize(); // Serialize form data
	            var updateUrl = $form.attr("action"); // Form action URL
	
	            // Additional Year/Month validation for forms with these fields
	            if ($form.find('select[name="y"]').length > 0) {
	                var yearValue = $form.find('select[name="y"]').val();
	                var monthValue = $form.find('select[name="m"]').val();
	
	                if (yearValue === "" && monthValue !== "") {
	                    return; // Prevent submission if Month is selected without Year
	                }
	            }
	
	            // Perform AJAX request
	            $.ajax({
	                url: updateUrl,
	                type: "POST",
	                data: data,
	                success: function success(data, textStatus, jqXHR) {
	                    _this2.$resultContainer.html(data); // Update results container
	                },
	                error: function error(resp) {
	                    console.error('Error submitting form:', resp); // Handle errors
	                }
	            });
	        }
	    }]);

	    return Search;
	}();

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Bookmark = exports.Bookmark = function () {
	    function Bookmark() {
	        _classCallCheck(this, Bookmark);
	    }
	
	    _createClass(Bookmark, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            $(document).on('click', '.js-add-bookmark-button', function (e) {
	                return _this.addBookmark(e);
	            });
	            $(document).on('click', '.js-remove-bookmark-button', function (e) {
	                return _this.removeBookmark(e);
	            });
	        }
	    }, {
	        key: 'addBookmark',
	        value: function addBookmark(e) {
	            e.preventDefault();
	
	            var $button = $('.js-add-bookmark-button');
	            var pagelink = $button.attr("data-value");
	            var userId = $button.attr("data-id");
	
	            $.ajax({
	                type: 'POST',
	                url: '/api/account/addbookmark/',
	                contentType: "application/json",
	                data: JSON.stringify({ "PageLink": pagelink, "UserId": userId }),
	                success: function success() {
	                    // refresh the page if username and password are correct
	                    location.reload();
	                },
	                error: function error(e1, e2) {}
	            });
	        }
	    }, {
	        key: 'removeBookmark',
	        value: function removeBookmark(e) {
	            e.preventDefault();
	
	            var $button = $('.js-remove-bookmark-button');
	            var pagelink = $button.attr("data-value");
	            var userId = $button.attr("data-id");
	
	            $.ajax({
	                type: 'POST',
	                url: '/api/account/removebookmark/',
	                contentType: "application/json",
	                data: JSON.stringify({ "PageLink": pagelink, "UserId": userId }),
	                success: function success() {
	                    // refresh the page if username and password are correct
	                    location.reload();
	                }
	            });
	        }
	    }, {
	        key: 'setLoginErrorMessage',
	        value: function setLoginErrorMessage(msg, clearFirst) {
	            if (clearFirst) $('#login-form-errors').html("");
	
	            if (msg) $('#login-form-errors').append(msg);
	        }
	    }]);

	    return Bookmark;
	}();

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Calendar = exports.Calendar = function () {
	    function Calendar() {
	        _classCallCheck(this, Calendar);
	    }
	
	    _createClass(Calendar, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            $(document).on('click', '.js-import-calendar-button', function (e) {
	                return _this.importCalendar(e);
	            });
	        }
	    }, {
	        key: 'importCalendar',
	        value: function importCalendar(e) {
	            e.preventDefault();
	
	            var $button = $('.js-import-calendar-button');
	            var pagelink = $button.attr("data-value");
	
	            $.ajax({
	                type: 'GET',
	                url: '/api/account/importcalendar/',
	                data: { Pagelink: pagelink },
	                success: function success() {
	                    // refresh the page if username and password are correct
	                    location.reload();
	                }
	            });
	        }
	    }, {
	        key: 'setLoginErrorMessage',
	        value: function setLoginErrorMessage(msg, clearFirst) {
	            if (clearFirst) $('#login-form-errors').html("");
	
	            if (msg) $('#login-form-errors').append(msg);
	        }
	    }]);

	    return Calendar;
	}();

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AlertBlock = exports.AlertBlock = function () {
	    function AlertBlock(inputSelector) {
	        _classCallCheck(this, AlertBlock);
	
	        this.$alertButton = $(inputSelector);
	    }
	
	    _createClass(AlertBlock, [{
	        key: "init",
	        value: function init() {
	            var _this = this;
	
	            this.$alertButton.click(function (e) {
	                return _this.alertDismissButtonClick(e);
	            });
	            this.$alertButton.each(function (index, value) {
	                return _this.hideAlert(index, value);
	            });
	        }
	    }, {
	        key: "hideAlert",
	        value: function hideAlert(index, value) {
	            var button = $(value);
	            var alertId = button.data("alert-id");
	            var alert = button.closest('.alert');
	            var alwaysShow = alert.data("always-show");
	
	            if (this.checkCookie('alert-box-' + alertId) && alwaysShow !== "True") alert.hide();else alert.show();
	        }
	    }, {
	        key: "alertDismissButtonClick",
	        value: function alertDismissButtonClick(e) {
	            // Do not perform default action when button is clicked
	            e.preventDefault();
	            var button = $(e.currentTarget);
	            var alertId = button.data("alert-id");
	
	            /* If you just want the cookie for a session don't provide an expires
	             Set the path as root, so the cookie will be valid across the whole site */
	            this.setCookie('alert-box-' + alertId, 'closed', 1);
	        }
	    }, {
	        key: "setCookie",
	        value: function setCookie(cname, cvalue, exdays) {
	            var d = new Date();
	            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	            var expires = "expires=" + d.toUTCString();
	            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	        }
	    }, {
	        key: "getCookie",
	        value: function getCookie(cname) {
	            var name = cname + "=";
	            var ca = document.cookie.split(';');
	            for (var i = 0; i < ca.length; i++) {
	                var c = ca[i];
	                while (c.charAt(0) == ' ') {
	                    c = c.substring(1);
	                }
	                if (c.indexOf(name) == 0) {
	                    return c.substring(name.length, c.length);
	                }
	            }
	            return "";
	        }
	    }, {
	        key: "checkCookie",
	        value: function checkCookie(key) {
	            var cookie = this.getCookie(key);
	            if (cookie != "") {
	                return true;
	            } else {
	                return false;
	            }
	        }
	    }]);

	    return AlertBlock;
	}();

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrganizationList = exports.OrganizationList = function () {
	    function OrganizationList() {
	        _classCallCheck(this, OrganizationList);
	    }
	
	    _createClass(OrganizationList, [{
	        key: "init",
	        value: function init() {
	            $(document).on("click", ".organisation-list .chevron", function (event) {
	                var id = $(this).attr("data-id");
	                var childContainer = $(".child-container-" + id);
	
	                if ($(this).hasClass("active")) {
	                    childContainer.addClass("hidden");
	                    $(this).removeClass("active");
	                } else {
	                    childContainer.removeClass("hidden");
	                    $(this).addClass("active");
	                }
	            });
	        }
	    }]);

	    return OrganizationList;
	}();

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Workroom = exports.Workroom = function () {
	    function Workroom() {
	        _classCallCheck(this, Workroom);
	    }
	
	    _createClass(Workroom, [{
	        key: "init",
	        value: function init() {
	            $(".add-folder").click(function () {
	                if ($(this).parent().hasClass("add-folder-holder")) {
	                    $("#add-folder-foldername").val($("#subfolder-name").val());
	                    $("#add-folder-submit").click();
	                } else {
	                    $(this).parent().addClass("add-folder-holder");
	                }
	            });
	
	            $(".add-file-btn").click(function () {
	                $("#file-input").click();
	            });
	
	            $(".expand-button").click(function (event) {
	
	                var $this = $(event.target);
	                var parent = $this.closest('.group-header');
	
	                parent.toggleClass("expanded");
	            });
	
	            $(function () {
	
	                $(".panel-collapse").each(function () {
	                    if ($(this).hasClass("show")) {
	
	                        var headerGroup = $(this).siblings('.group-header');
	                        console.log(headerGroup);
	                        headerGroup.addClass("expanded");
	                    }
	                });
	            });
	
	            $(".work-room-popup").click(function () {
	                var folderName = $(this).siblings("h3").text();
	                var isLastLevel = $(this).siblings("input").attr("data-is-last-level");
	                var modal = $('#workroom-modal');
	
	                modal.find(".add-folder-holder").removeClass("add-folder-holder");
	                modal.find(".modal-title").html("Mapp: " + folderName);
	
	                $("#file-input-folder-name").val(folderName.trim());
	                $("#add-folder-parentname").val(folderName.trim());
	                $("#add-folder-foldername").val("");
	                modal.find(".add-folder").show();
	                if (isLastLevel === "True") {
	                    modal.find(".add-folder").hide();
	                }
	                modal.modal();
	            });
	        }
	    }]);

	    return Workroom;
	}();

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Quiz = exports.Quiz = function () {
	    function Quiz() {
	        _classCallCheck(this, Quiz);
	    }
	
	    _createClass(Quiz, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            $('.quiz-button__answer').on('click', function (e) {
	                return _this.getAnswer(e);
	            });
	            $('.quiz-button-next').on('click', function (e) {
	                return _this.nextQuestion(e);
	            });
	
	            $('.is-hidden').hide();
	        }
	
	        // Handle answered question, show right/wrong answers
	
	    }, {
	        key: 'getAnswer',
	        value: function getAnswer(e) {
	            e.preventDefault();
	            var pressedAnswer = $(e.currentTarget);
	            var answeredId = pressedAnswer.data('id');
	
	            var questionId = pressedAnswer.closest('.quiz-question').data('contentlink');
	            var question = $('[data-contentlink=' + questionId + ']').first();
	            var answerInfo = question.find('.quiz-question__answer-text').first();
	
	            $.ajax({
	                type: 'GET',
	                url: '/api/quiz/getquizanswer/?questionId=' + questionId,
	                contentType: "application/json; charset=utf-8",
	                dataType: 'json',
	                success: function success(data) {
	
	                    var answerInfoText = data[0];
	                    var correctAnswerId = data[1];
	
	                    if (answeredId == correctAnswerId) {
	                        // User gave correct answer, add 1 to score
	                        var currentScore = sessionStorage.getItem("quizScore");
	                        if (!currentScore) {
	                            currentScore = 0;
	                        }
	
	                        sessionStorage.setItem("quizScore", parseInt(currentScore) + 1);
	                    } else {
	                        // Sorry, wrong answer
	                        question.find('[data-id=' + answeredId + ']').addClass('wrong-answer');
	                    }
	                    question.find('[data-id=' + answeredId + ']').addClass('given-answer');
	                    question.find('[data-id=' + correctAnswerId + ']').addClass('right-answer');
	                    question.find('.quiz-button__answer').unbind();
	                    $('.quiz-button__answer').addClass('quiz-button__disabled');
	                    $('.quiz-button-next').show();
	                    $('.quiz-button-next').removeClass('quiz-button__disabled');
	                    answerInfo.show().html(answerInfoText);
	                },
	                error: function error(_error) {
	                    // Add error message to view
	                    answerInfo.show().html("Något gick fel, vi kunde inte hitta det rätta svaret.");
	                }
	            });
	        }
	
	        // Handle parts of page, start/questions/end-parts
	
	    }, {
	        key: 'nextQuestion',
	        value: function nextQuestion(e) {
	            e.preventDefault();
	            var button = $('.quiz-button-next');
	            var currentIndex = button.data('index');
	            var numberOfQuestions = $('#numberOfQuestions').val();
	
	            var nextIndex = currentIndex + 1;
	            var nextButtonText = "Nästa fråga";
	            var nextButtonClass = "quiz-button-next__next";
	
	            // Hide and show next part of page
	            $('.quiz-question').hide();
	            $('.quiz-end').hide();
	            $('.quiz-question-' + nextIndex).show();
	            $('.quiz-button__answer').show();
	
	            if (currentIndex == 0) {
	                // Reset score when starting a quiz
	                sessionStorage.setItem("quizScore", 0);
	            }
	
	            if (nextIndex == numberOfQuestions) {
	                // Last question, change button text
	                nextButtonText = "Avsluta & se resultat";
	                nextButtonClass = "quiz-button-next__last";
	            } else if (nextIndex > numberOfQuestions) {
	                // Reset index when quiz ends
	                nextIndex = 0;
	                currentIndex = 0;
	                button.hide();
	                $('.quiz-button__end').show();
	
	                // Show result and end text
	                var score = sessionStorage.getItem("quizScore");
	                var endText = $('.quiz-end').html();
	                var finalEndText = endText.replace("x/y", score + "/" + numberOfQuestions);
	                $('.quiz-end').html(finalEndText).show();
	            }
	
	            if (nextIndex != 0 && nextIndex <= numberOfQuestions) {
	                $('.quiz-button__answer').removeClass('quiz-button__disabled');
	                button.addClass('quiz-button__disabled');
	                button.hide();
	            }
	            button.removeClass('quiz-button-next__start');
	            button.removeClass('quiz-button-next__next');
	            button.removeClass('quiz-button-next__last');
	            button.addClass(nextButtonClass);
	            button.html(nextButtonText);
	            button.data("index", nextIndex);
	        }
	    }]);

	    return Quiz;
	}();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.min.js